import {Update_UpdateAbortAlarmTime,Fetch_Offline_Duration_Setting_Data,Update_Offline_Duration_Setting_Success,
    Update_UpdateLifeguardDefibrillatorCprText,Fetch_UpdateLifeguardDefibrillatorCprText,Update_Registration_Header_Setting_Success,Update_Registration_Text_Setting_Success,
    Fetch_Request, Update_Setting_Success} from '../action/generalSettingAction';
import {generalSettingState} from '../state/generalSettingState';

export function generalSettingReducer(state = generalSettingState, action) {
    switch(action.type){
           case Fetch_UpdateLifeguardDefibrillatorCprText:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                allSetting : action.allSetting
            })
        case Update_UpdateLifeguardDefibrillatorCprText:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                message : action.message,
                responseValue : action.updatedValue
            })
             case Update_UpdateAbortAlarmTime:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                message : action.message,
                responseValue : action.updatedValue
            })





        case Fetch_Offline_Duration_Setting_Data:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                allSetting : action.allSetting
            })
        case Update_Offline_Duration_Setting_Success:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                message : action.message,
                responseValue : action.updatedValue
            })
            case Update_Registration_Header_Setting_Success:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                message : action.message,
                responseValue : action.updatedValue
            })
            case Update_Registration_Text_Setting_Success:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                message : action.message,
                responseValue : action.updatedValue
            })
            case Fetch_Request:
                return Object.assign({}, state, {
                    responseValue : '',
                    statusCode : 0
                })
            case Update_Setting_Success:
                return Object.assign({}, state , {
                    errorCode : action.errorCode,
                    statusCode : action.statusCode,
                    message : action.message,
                    responseValue : action.responseValue
                })
        default:
            return state
    }
}